import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "@/components/site/Hero";
import EmergencyMarquee from "@/components/site/EmergencyMarquee";
import Services from "@/components/site/Services";
import EVCitiesStrip from "@/components/site/EVCitiesStrip";
import Manifesto from "@/components/site/Manifesto";
import OurWork from "@/components/site/OurWork";
import BlogStrip from "@/components/site/BlogStrip";
import EmergencyBanner from "@/components/site/EmergencyBanner";
import About from "@/components/site/About";
import Reviews from "@/components/site/Reviews";
import ServiceAreas from "@/components/site/ServiceAreas";
import ContactSection from "@/components/site/ContactSection";
import useSEO from "@/hooks/useSEO";

export default function Home() {
  const { hash } = useLocation();
  useSEO({
    title: "Vancouver Electricians · EV, Panel Upgrades, Security & 24/7 Emergency | ElectroMax Systems",
    description:
      "Metro Vancouver's licensed electricians for Level 2 EV chargers, 200-amp panel upgrades, hardwired security & automation, and 24/7 emergency response. TSBC licensed, fully insured, transparent flat-rate pricing.",
  });

  // Handle cross-page anchor navigation: /#services from another route.
  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: "auto" });
      return;
    }
    const t = setTimeout(() => {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 60);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <div data-testid="home-page">
      <Hero />
      <EmergencyMarquee />
      <Services />
      <EVCitiesStrip variant="ev" />
      <EVCitiesStrip variant="panel" />
      <Manifesto />
      <OurWork />
      <EmergencyBanner />
      <About />
      <Reviews />
      <BlogStrip />
      <ServiceAreas />
      <ContactSection />
    </div>
  );
}
